import React,{useState} from 'react';
import {NavLink} from 'react-router-dom';
import {Link} from 'react-scroll'
import { animateScroll as scroll } from 'react-scroll';
import './Navbar.css';

export default function Navbar() {
    const [click, setClick] = useState(false);
    
    const handleClick =()=>{
        setClick(!click);
    }
    return (
        <>
        <nav className='navbar-container'>
            <div className='title' onClick={()=>scroll.scrollToTop}>
                <img className='logo' src='/images/avalokana.jpeg' alt='logo'/>
                <h1>Avalokana</h1>
            </div>
            <div className='navbar'>
            <div class="icon" onClick={handleClick}>
                <i class={click ? "fas fa-times":"fas fa-bars"}></i>
            </div>
            <ul className={click ? 'nav-container1 active':'nav-container1'}>
                <NavLink className='nav-link' to='/' onClick={handleClick}><li>Home</li></NavLink>
                <NavLink className='nav-link' to='/events' onClick={handleClick}><li>Events</li></NavLink>
                <NavLink className='nav-link' to='/blog' onClick={handleClick}><li>Blog</li></NavLink>
                <Link className='nav-link' to="footer-wrapper" smooth={true} duration={1000}><li>Contact Us</li></Link>
                {/* <li><i class={click ? "fas fa-sun" : "fas fa-moon"} onClick={changeIcon}></i></li>*/}
            </ul>
            </div>  
        </nav>
        </>
    )
}
